import { render, staticRenderFns } from "./menuNav.vue?vue&type=template&id=2410a695&scoped=true"
import script from "./menuNav.vue?vue&type=script&lang=js"
export * from "./menuNav.vue?vue&type=script&lang=js"
import style0 from "./menuNav.vue?vue&type=style&index=0&id=2410a695&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2410a695",
  null
  
)

export default component.exports